import { ChevronDown, FileCode, FileText, Folder, Lock } from "lucide-react";
import { useMemo } from "react";

function buildFlat(paths) {
  const root = {};
  for (const p of paths) {
    const parts = p.split("/").filter(Boolean);
    let node = root;
    parts.forEach((part, idx) => {
      const isFile = idx === parts.length - 1;
      if (!node[part]) {
        node[part] = { __isFile: isFile, __path: parts.slice(0, idx + 1).join("/"), children: {} };
      }
      node = node[part].children;
    });
  }
  const out = [];
  const walk = (nodes, depth) => {
    const entries = Object.entries(nodes).sort((a, b) => {
      const aFile = a[1].__isFile;
      const bFile = b[1].__isFile;
      if (aFile !== bFile) return aFile ? 1 : -1; // folders first
      return a[0].localeCompare(b[0]);
    });
    for (const [name, node] of entries) {
      out.push({ name, path: node.__path, isFile: node.__isFile, depth });
      if (!node.__isFile) walk(node.children, depth + 1);
    }
  };
  walk(root, 0);
  return out;
}

function iconFor(name) {
  if (name.toLowerCase().endsWith(".py")) return FileCode;
  return FileText;
}

export const FileTree = ({ files = [], activePath, onSelect, locked = false }) => {
  const rows = useMemo(() => buildFlat(["SKILL.md", ...files.map((f) => f.filename)]), [files]);
  return (
    <div data-testid="skill-files-tree" className="text-sm">
      <ul className="space-y-0.5">
        {rows.map((row) => {
          const Icon = row.isFile ? iconFor(row.name) : Folder;
          const isActive = row.path === activePath;
          return (
            <li key={row.path + row.depth}>
              <button
                type="button"
                onClick={() => row.isFile && onSelect(row.path)}
                style={{ paddingLeft: 8 + row.depth * 14 }}
                className={`group flex w-full items-center gap-2 rounded-lg py-1.5 pr-2 text-left text-[13px] transition-colors ${
                  isActive
                    ? "bg-[color:rgba(45,212,191,0.10)] text-[color:var(--rb-text)]"
                    : "text-[color:var(--rb-text-dim)] hover:bg-white/5 hover:text-[color:var(--rb-text)]"
                } ${row.isFile ? "cursor-pointer" : "cursor-default"}`}
              >
                {!row.isFile && <ChevronDown className="h-3.5 w-3.5 opacity-60" />}
                <Icon className={`h-3.5 w-3.5 ${row.isFile ? "text-[color:var(--rb-accent)]" : "text-[color:var(--rb-text-faint)]"}`} />
                <span className="rb-mono truncate">{row.name}</span>
                {row.isFile && locked && <Lock className="ml-auto h-3 w-3 text-[color:var(--rb-gold)]" />}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
